export default __webpack_public_path__ + "static/media/leaderboard-search.00bbab8d.svg";